import { render } from "./Main.vue?vue&type=template&id=3ca42fa8"
const script = {}
script.render = render

export default script